export default {
  home: {
    title: 'Beranda',
    aiBannerTxt: {
      title: 'Mewujudkan Pendidikan AI',
      subtitle: 'Pemberdayaan Digital AI+ Pendidikan, Mengintegrasikan Konsep Inovatif',
      description: 'Fokus pada produk dan layanan teknis kustomisasi laser, membantu lembaga & perusahaan mengintegrasikan "AI+ Education"'
    },
    description: 'Selamat datang di situs pemasaran Vue.js kami',
    banner: {
      slide1: {
        title: 'Paket STEAM | Paket AI | Paket Pemotongan Laser',
        description:
          'Kami menyediakan solusi pendidikan STEAM yang inovatif dan beragam paket untuk keluarga, pendidik, dan distributor, dirancang untuk anak usia 3–16 tahun.',
      },
      slide2: {
        title: 'Paket profesional yang dirancang untuk kreativitas anak',
        description:
          'Kursus, perangkat, dan perangkat lunak terpadu untuk pembelajaran berbasis proyek',
      },
      slide3: {
        title: 'Pendidikan teknologi untuk masa depan',
        description:
          'Praktik langsung, integrasi lintas disiplin, membangun kemampuan pemecahan masalah dan kolaborasi',
      },
    },
    factory: {
      banner: {
        alt: 'Banner Pabrik Cerdas',
        title: 'Solusi Pabrik Cerdas',
        description:
          'Pembangunan lini produksi | Sensor industri | Kontrol PLC & akuisisi data',
        image: 'https://picsum.photos/seed/factory-banner/1000/600',
      },
      resourcesTitle: 'Sumber belajar',
      resources: [
        {
          title: 'Materi pembelajaran berbasis proyek',
          desc: 'PPT kursus dan handout, desain aktivitas kelas dan saran penilaian.',
          image: 'https://picsum.photos/seed/factory-res-1/374/217',
        },
        {
          title: 'Contoh skenario & aset',
          desc: 'Contoh kontrol konveyor, deteksi stasiun kerja, integrasi perangkat, beserta cuplikan kode.',
          image: 'https://picsum.photos/seed/factory-res-2/374/217',
        },
        {
          title: 'Tugas pengayaan setelah kelas',
          desc: 'Tugas lanjutan dan saran penerapan lintas disiplin untuk mendorong eksplorasi dan kreasi.',
          image: 'https://picsum.photos/seed/factory-res-3/374/217',
        },
      ],
      intro: {
        title: 'Perkenalan Produk',
        desc: 'Solusi pabrik cerdas berfokus pada pembangunan lini produksi dan kontrol pemrograman, mencakup sensor industri, identifikasi stasiun kerja, kontrol PLC/mikrokontroler dan akuisisi data, menekankan praktik dan pelatihan sistematis.',
        bg: 'https://picsum.photos/seed/factory-bg/1200/736',
      },
      course: {
        title: 'Kursus pendamping',
        desc: 'Dirancang seputar pembangunan lini produksi, sensor industri, kontrol PLC dan akuisisi data, menekankan praktik dan pelatihan sistematis.',
        image: 'https://picsum.photos/seed/factory-course/668/597',
      },
      equipments: [
        {
          title: 'Modul konveyor',
          image: 'https://picsum.photos/seed/factory-eq-1/209/209',
        },
        {
          title: 'Sensor fotoelektrik',
          image: 'https://picsum.photos/seed/factory-eq-2/209/209',
        },
        {
          title: 'Unit kontrol PLC',
          image: 'https://picsum.photos/seed/factory-eq-3/209/209',
        },
        {
          title: 'Modul lengan robot',
          image: 'https://picsum.photos/seed/factory-eq-4/209/209',
        },
        {
          title: 'Modul pengenal barcode',
          image: 'https://picsum.photos/seed/factory-eq-5/209/209',
        },
        {
          title: 'Sensor suhu & kelembapan',
          image: 'https://picsum.photos/seed/factory-eq-6/209/209',
        },
        {
          title: 'Modul penggerak motor',
          image: 'https://picsum.photos/seed/factory-eq-7/209/209',
        },
        {
          title: 'Modul deteksi stasiun',
          image: 'https://picsum.photos/seed/factory-eq-8/209/209',
        },
        {
          title: 'Modul tombol darurat',
          image: 'https://picsum.photos/seed/factory-eq-9/209/209',
        },
        {
          title: 'Gateway akuisisi data',
          image: 'https://picsum.photos/seed/factory-eq-10/209/209',
        },
      ],
    },
    solutions: {
      title: 'Solusi Pendidikan STEAM Zetok',
      learnMore: 'Pelajari lebih lanjut >',
      items: [
        {
          image: require('@/assets/home/solution1.webp'),
          title: 'Paket Zetok',
          description:
            'Melalui praktik dan pembelajaran berbasis proyek, mengembangkan pola pikir inovatif dan keterampilan praktik.',
          link: '/solutions/kits',
        },
        {
          image: require('@/assets/home/solution2.webp'),
          title: 'Good Laser Mesin Pemotong & Ukir Laser',
          description:
            'Mesin laser menghadirkan pengalaman belajar praktis baru bagi pendidikan STEAM',
          link: '/solutions/laser',
        },
      ],
    },
    scenes: {
      title: 'Skenario Pengajaran',
      items: [
        {
          image: require('@/assets/home/education1.webp'),
          title: 'Solusi Pendidikan STEM',
        },
        {
          image: require('@/assets/home/education2.webp'),
          title: 'Solusi Maker Space',
        },
      ],
    },
    aiBanner: {
      alt: 'Banner AI',
      image: require('@/assets/home/aibanner.png'),
    },
    kitsSection: {
      alt: 'Paket Zetok',
      title: 'Paket Kecerdasan Buatan',
      description:
        'Paket AI biasanya mencakup proyek interaktif dan praktis yang kaya, mampu memicu minat dan rasa ingin tahu siswa terhadap teknologi.',
      image: require('@/assets/home/kitsbanner.png'),
    },
    kitsCarousel: {
      alt: 'Carousel Paket',
      title: 'Tingkatkan Pola Pikir Inovatif',
      items: [
        { image: require('@/assets/home/kits1.png') },
        { image: require('@/assets/home/kits2.png') },
        { image: require('@/assets/home/kits3.png') },
        { image: require('@/assets/home/kits4.png') },
        { image: require('@/assets/home/kits5.png') },
        { image: require('@/assets/home/kits6.png') },
        { image: require('@/assets/home/kits7.png') },
        { image: require('@/assets/home/kits8.png') },
        { image: require('@/assets/home/kits9.png') },
      ],
    },
    products: {
      title: 'Paket Zetok dan Mesin Laser Good Laser',
      tabs: {
        kits: 'Paket',
        courses: 'Kursus',
        laser: 'Perangkat Laser',
        software: 'Perangkat Lunak',
      },
      items: {
        kits: [
          {
            image: require('@/assets/home/product1.webp'),
            title: 'Paket Pemula Pemotongan Laser',
            description: '(Bahan papan kayu pendamping)',
          },
          {
            image: require('@/assets/home/product2.webp'),
            title: 'Kotak Sains Menakjubkan',
            description: '(Papan kayu + paket kit sirkuit mikro)',
          },
          {
            image: require('@/assets/home/product3.webp'),
            title: 'Paket Pemrograman AI',
            description: '',
          },
        ],
        courses: [
          {
            image: require('@/assets/home/product4.webp'),
            title: 'Sistem Eksplorasi Sains - Anak Usia Dini',
            description: '(6 mata pelajaran)',
          },
          {
            image: require('@/assets/home/product5.webp'),
            title: 'Sistem Maker STEAM - Remaja',
            description: '(3 mata pelajaran)',
          },
          {
            image: require('@/assets/home/product6.webp'),
            title: 'Kursus Pemotongan Laser',
            description: '(3 mata pelajaran)',
          },
          {
            image: require('@/assets/home/product7.webp'),
            title: 'Sistem Kursus Kecerdasan Buatan',
            description: '(4 mata pelajaran)',
          },
        ],
        laser: [
          {
            image: require('@/assets/home/product8.png'),
            title: 'Light 530 ',
            description: 'Mesin pemotong & ukir laser CO2 desktop 55W',
          },
          {
            image: require('@/assets/home/product9.png'),
            title: 'Light 640',
            description: 'Mesin pemotong & ukir laser profesional',
          },
          {
            image: require('@/assets/home/product10.png'),
            title: 'Light Blue 530 ',
            description: 'Mesin pemotong & ukir laser biru desktop pintar',
          },
          {
            image: require('@/assets/home/product11.png'),
            title: 'Mark M20',
            description: 'Mesin penanda laser presisi tinggi',
          },
        ],
        software: [
          {
            image: require('@/assets/home/product12.png'),
            title: 'Platform Belajar Zetok',
            description: '',
          },
          {
            image: require('@/assets/home/product13.png'),
            title: 'Platform Cloud Zetok',
            description: '',
          },
          {
            image: require('@/assets/home/product14.png'),
            title: 'Light Maker',
            description: '',
          },
          {
            image: require('@/assets/home/product15.png'),
            title: 'mind+',
            description: '',
          },
          {
            image: require('@/assets/home/product16.png'),
            title: 'Arduino',
            description: '',
          },
        ],
      },
    },
  },
  switch_lang: 'Bahasa Indonesia',
  nav: {
    products: 'Produk',
    smartFarm: 'Pertanian Cerdas',
    smartHome: 'Rumah Cerdas',
    smartTraffic: 'Transportasi Cerdas',
    smartFactory: 'Pabrik Cerdas',
    laserSteam: 'Paket STEAM Pemotongan Laser',
    dreamScience: 'Paket Sains Impian',
    course: 'Kursus',
    device: 'Perangkat',
    education: 'Solusi Pendidikan',
    stem: 'Solusi Pendidikan STEM',
    maker: 'Solusi Maker Space',
    software: 'Perangkat Lunak',
    service: 'Layanan & Dukungan',
    afterSale: 'Unduhan Tutorial',
    about: 'Tentang Kami',
    aboutUs: 'Tentang Kami',
    dealer: 'Menjadi Distributor Kami',
    cooperation: 'Kerja Sama Penggunaan Produk & Pendidikan',
    news: 'Berita',
    coursesSeries: 'Empat Seri Kursus',
    viewMore: 'Lihat Lebih Banyak',
    store: 'Toko'
  },
  globalContactForm: {
    title: 'Hubungi Kami',
    subtitle:
      'Jika Anda memiliki pertanyaan atau kebutuhan, silakan hubungi kami kapan saja; kami siap membantu.',
    fields: {
      name: 'Nama',
      email: 'Email',
      phone: 'Telepon',
      company: 'Perusahaan',
      message: 'Pesan',
    },
    placeholders: {
      name: 'Silakan masukkan nama',
      email: 'Silakan masukkan alamat email',
      phone: 'Silakan masukkan nomor telepon',
      company: 'Silakan masukkan nama perusahaan',
      message: 'Silakan tulis kebutuhan atau pertanyaan Anda',
    },
    validation: {
      name: 'Silakan masukkan nama',
      email: 'Silakan masukkan alamat email',
      emailFormat: 'Format email tidak valid',
      phone: 'Silakan masukkan nomor telepon',
      message: 'Silakan isi pesan',
    },
    submit: 'Kirim',
    submitting: 'Mengirim…',
    visual: {
      title: 'Layanan Profesional',
      description:
        'Fokus pada pendidikan kreativitas teknologi anak usia 3–16 tahun, membangun ruang inovasi, mengembangkan produk dan kurikulum terkait.',
    },
    contact: {
      phone: 'Layanan Hotline',
      email: 'Alamat Email',
    },
  },
  thankYou: {
    metaTitle: 'Terima kasih atas kiriman Anda',
    title: 'Terima kasih atas kiriman Anda!',
    description:
      'Kami telah menerima informasi Anda dan akan segera menghubungi.',
    seoDescription:
      'Pengiriman berhasil, tim kami akan segera menghubungi Anda.',
    backHome: 'Kembali ke Beranda',
    browseProducts: 'Lanjutkan menjelajahi produk',
    contactSupport: 'Hubungi dukungan purna jual',
    nextStepsTitle: 'Langkah berikutnya',
    nextSteps: [
      'Kami akan meninjau permintaan Anda dalam 1–2 hari kerja.',
      'Jika membutuhkan informasi tambahan, kami akan menghubungi Anda.',
      'Anda dapat terus menjelajah situs atau menghubungi kami melalui telepon/email.',
    ],
    contactTitle: 'Butuh bantuan segera?',
    contactPhoneLabel: 'Hotline:',
    contactEmailLabel: 'Email:',
  },
  about: {
    banner: {
      alt: 'Banner Tentang Kami',
      title:
        'Zetok berfokus pada pendidikan inovatif, menyediakan paket dan kursus berkualitas tinggi',
      image: require('@/assets/about/banner.png'),
    },
    mission: {
      title: 'Misi Kami',
      desc: 'Misi kami adalah memberdayakan pendidikan melalui teknologi AI canggih, memicu inovasi, dan membina pemimpin serta inovator masa depan. Kami percaya dengan menyediakan alat dan solusi pendidikan berkualitas, kami membantu siswa dan pendidik mencapai potensi mereka.',
      image: require('@/assets/about/mission.png'),
    },
    vision: {
      title: 'Visi Kami',
      desc: 'Teknologi memberdayakan pendidikan, membantu setiap siswa mengakses sumber STEM berkualitas, memicu potensi, membina inovator dan pemimpin masa depan.',
      image: require('@/assets/about/vision.png'),
    },
    products: {
      title: 'Produk Kami',
      tabs: ['Paket', 'Kursus', 'Perangkat Laser'],
      items: [
        {
          title: 'Paket',
          desc: 'Kami menyediakan beragam paket STEM termasuk AI, robotika, pemrograman, dan eksperimen sains, dirancang dengan baik, mudah digunakan, cocok untuk berbagai usia.',
          image: require('@/assets/about/kits.png'),
        },
        {
          title: 'Kursus',
          desc: 'Kursus kami dirancang oleh pakar pendidikan untuk terintegrasi dengan paket, memberikan pengalaman belajar menyeluruh. Materi mencakup konsep dasar hingga aplikasi lanjutan, cocok untuk berbagai level.',
          image: require('@/assets/about/courses.png'),
        },
        {
          title: 'Perangkat Laser',
          desc: 'Perangkat pemotongan dan ukir laser kami dirancang untuk lingkungan pendidikan: aman, presisi, dan mudah dioperasikan. Perangkat ini memberi siswa kesempatan mengubah ide menjadi karya nyata.',
          image: require('@/assets/about/laser.png'),
        },
      ],
    },
    dealer: {
      banner: {
        alt: 'Bergabunglah dengan kami, menjadi distributor Zetok',
        title: 'Bergabunglah dengan kami, menjadi distributor Zetok',
        image: require('@/assets/about/dealer.png'),
      },
      intro: {
        title: 'Buka peluang baru di bidang pendidikan, berbagi hasil inovasi!',
        desc: 'Zetok mengundang Anda mengembangkan jalur baru pendidikan STEM, menyediakan paket AI, perangkat laser, dan lainnya, memicu kreativitas siswa; mari bergabung untuk meraih masa depan bersama!',
        image: require('@/assets/about/dealer1.png'),
      },
      mission: {
        title: 'Misi Kami',
        items: [
          {
            title: 'Produk unggul',
            desc: 'Dapatkan alat pendidikan STEAM berkualitas di pasar.',
            image: require('@/assets/about/dealer-mission-1.png'),
          },
          {
            title: 'Imbalan yang menarik',
            desc: 'Nikmati diskon kompetitif dan insentif penjualan.',
            image: require('@/assets/about/dealer-mission-2.png'),
          },
          {
            title: 'Dukungan pemasaran',
            desc: 'Sediakan materi pemasaran dan pelatihan penjualan untuk membantu Anda membuka pasar dengan cepat.',
            image: require('@/assets/about/dealer-mission-3.png'),
          },
          {
            title: 'Kolaborasi merek',
            desc: 'Bekerja sama dengan Zetok, berbagi kekuatan merek dan sumber daya pasar.',
            image: require('@/assets/about/dealer-mission-4.png'),
          },
        ],
      },
    },
    cooperation: {
      banner: {
        alt: 'Banner Kerja Sama',
        title: 'Kerja Sama Produk',
        cta: 'Hubungi sekarang',
        ctaLink: '/about#contact',
        image: require('@/assets/about/coop-introbanner.png'),
      },
      intro: {
        title: 'Bangkitkan potensi ilmuwan dan insinyur masa depan',
        desc: 'Bergabung dengan program promosi pendidikan STEM kami untuk mendapatkan penawaran khusus dan uji coba produk yang dirancang untuk pendidik. Kami menyediakan alat STEM inovatif untuk kelas serta diskon eksklusif untuk membantu Anda membina inovator dan pemecah masalah generasi berikutnya.',
        image: require('@/assets/about/coop-introbanner1.png'),
      },
      stem: {
        title: 'Bertindak sekarang, buka babak baru pendidikan STEM!',
        items: [
          {
            title: 'Uji coba produk gratis',
            desc: 'Coba alat kami sebelum membeli.',
            image: require('@/assets/about/edu1.png'),
          },
          {
            title: 'Diskon eksklusif',
            desc: 'Memberikan solusi STEM yang terjangkau untuk kelas atau sekolah Anda.',
            image: require('@/assets/about/edu2.png'),
          },
          {
            title: 'Sumber daya pendidikan',
            desc: 'Menyediakan sumber belajar dan rencana pelajaran yang kaya untuk mendukung kegiatan mengajar Anda.',
            image: require('@/assets/about/edu3.png'),
          },
        ],
      },
      contact: {
        title: 'Hubungi Kami',
        desc: 'Jika ada pertanyaan atau kebutuhan, silakan hubungi kami; kami siap membantu Anda.',
        image: require('@/assets/about/kites.png'),
      },
    },
    news: {
      banner: {
        alt: 'Banner Pusat Berita',
        title: 'Pusat Berita',
        image: require('@/assets/about/newsbanner.png'),
      },
      title: 'Pusat Berita',
      tabs: [
        { key: 'company', label: 'Perusahaan' },
        { key: 'industry', label: 'Industri' },
        { key: 'expo', label: 'Pameran' },
      ],
      data: {
        company: [
          {
            id: 'company-1',
            title: 'Zhongze meluncurkan paket AI kelas terbaru',
            date: '2025-04-22',
            image: 'https://picsum.photos/seed/news-company-1-zh/560/342',
          },
          {
            id: 'company-2',
            title:
              'Berkolaborasi dengan sekolah lokal untuk proyek percontohan STEM',
            date: '2025-04-15',
            image: 'https://picsum.photos/seed/news-company-2-zh/560/342',
          },
          {
            id: 'company-3',
            title:
              'Pembaruan perangkat lunak meningkatkan pengalaman manajemen kelas',
            date: '2025-03-30',
            image: 'https://picsum.photos/seed/news-company-3-zh/560/342',
          },
          {
            id: 'company-4',
            title: 'Mengadakan lokakarya pelatihan guru',
            date: '2025-03-18',
            image: 'https://picsum.photos/seed/news-company-4-zh/560/342',
          },
          {
            id: 'company-5',
            title: 'Jaringan distributor menjangkau lebih banyak wilayah',
            date: '2025-03-02',
            image: 'https://picsum.photos/seed/news-company-5-zh/560/342',
          },
          {
            id: 'company-6',
            title: 'Seri kursus baru berfokus pada praktik proyek nyata',
            date: '2025-02-20',
            image: 'https://picsum.photos/seed/news-company-6-zh/560/342',
          },
          {
            id: 'company-7',
            title: 'Tinjauan tahunan menyoroti hasil inovasi',
            date: '2025-02-05',
            image: 'https://picsum.photos/seed/news-company-7-zh/560/342',
          },
          {
            id: 'company-8',
            title: 'Program sosial komunitas membawa STEM kepada remaja',
            date: '2025-01-25',
            image: 'https://picsum.photos/seed/news-company-8-zh/560/342',
          },
        ],
        industry: [
          {
            id: 'industry-1',
            title:
              'Tren global: penerapan pembelajaran berbasis proyek dalam STEM',
            date: '2025-04-10',
            image: 'https://picsum.photos/seed/news-industry-1-zh/560/342',
          },
          {
            id: 'industry-2',
            title: 'AI dalam pendidikan: praktik terbaik yang muncul',
            date: '2025-03-25',
            image: 'https://picsum.photos/seed/news-industry-2-zh/560/342',
          },
          {
            id: 'industry-3',
            title: 'Standar kurikulum baru menekankan keterampilan praktik',
            date: '2025-03-12',
            image: 'https://picsum.photos/seed/news-industry-3-zh/560/342',
          },
          {
            id: 'industry-4',
            title: 'Perangkat keras pendidikan semakin sesuai kebutuhan kelas',
            date: '2025-02-28',
            image: 'https://picsum.photos/seed/news-industry-4-zh/560/342',
          },
          {
            id: 'industry-5',
            title: 'Proyek STEAM terus berkembang di berbagai distrik',
            date: '2025-02-14',
            image: 'https://picsum.photos/seed/news-industry-5-zh/560/342',
          },
          {
            id: 'industry-6',
            title: 'Proyek keberlanjutan masuk ke kelas STEM',
            date: '2025-01-30',
            image: 'https://picsum.photos/seed/news-industry-6-zh/560/342',
          },
          {
            id: 'industry-7',
            title: 'Maker space memengaruhi cara belajar inovatif',
            date: '2025-01-16',
            image: 'https://picsum.photos/seed/news-industry-7-zh/560/342',
          },
        ],
        expo: [
          {
            id: 'expo-1',
            title: 'Zhongze tampil di pameran teknologi pendidikan',
            date: '2025-04-05',
            image: 'https://picsum.photos/seed/news-expo-1-zh/560/342',
          },
          {
            id: 'expo-2',
            title: 'Menampilkan hasil proyek siswa di pameran regional',
            date: '2025-03-22',
            image: 'https://picsum.photos/seed/news-expo-2-zh/560/342',
          },
          {
            id: 'expo-3',
            title: 'Demo interaktif acara maker menarik perhatian',
            date: '2025-03-08',
            image: 'https://picsum.photos/seed/news-expo-3-zh/560/342',
          },
          {
            id: 'expo-4',
            title: 'Lokakarya pemrograman visual untuk guru',
            date: '2025-02-21',
            image: 'https://picsum.photos/seed/news-expo-4-zh/560/342',
          },
          {
            id: 'expo-5',
            title: 'Menampilkan perangkat baru untuk mitra pendidikan',
            date: '2025-02-09',
            image: 'https://picsum.photos/seed/news-expo-5-zh/560/342',
          },
        ],
      },
    },
  },
  finance: {
    contact: {
      success: 'Pengiriman berhasil, kami akan segera menghubungi Anda',
      error: 'Pengiriman gagal, silakan coba lagi nanti',
      networkError: 'Gangguan jaringan, periksa koneksi lalu coba lagi',
    },
  },
  footer: {
    subscribePlaceholder: 'Nomor ponsel dan alamat email Anda',
    subscribe: 'Berlangganan',
    subscribeSuccess: 'Berlangganan berhasil',
    contact: {
      sales: 'Hotline Penjualan: +86 18379276683',
      service: 'Hotline Layanan: +86 400 968 0598',
      email: 'Email: sam@zz-steam.com',
      address:
        'Alamat: Gedung Huashengda Blok A, Bagua 4th Road, Futian, Shenzhen',
    },
    icp: 'Kebijakan Privasi · Perjanjian Pengguna Hak Cipta © Zhongze Education (Shenzhen) Co., Ltd. 粤ICP备2024289240号-3',
  },
  solutions: {
    stem: {
      banner: {
        alt: 'Banner Solusi Pendidikan STEM',
        title: 'Kreativitas memimpin pendidikan STEM',
        description:
          'Untuk K12, kami fokus pada pendidikan STEM kreatif, membangkitkan rasa ingin tahu, melatih logika, dan menyalakan semangat pemrograman.',
        image: require('@/assets/solution/banner.png'),
      },
      intro: {
        title: 'Pendidikan AI dan Pemrograman',
        items: [
          {
            icon: require('@/assets/solution/icon1.png'),
            title: 'Mudah dipelajari & digunakan',
            description:
              'Pemrograman visual; pemula langsung bisa, mudah membuat proyek AI pribadi.',
          },
          {
            icon: require('@/assets/solution/icon2.png'),
            title: 'Fungsional kuat',
            description:
              'Perangkat keras cerdas, interaksi suara, kreativitas tanpa batas.',
          },
          {
            icon: require('@/assets/solution/icon3.png'),
            title: 'Sangat dapat diperluas',
            description:
              'Sambungkan komponen perangkat keras, memicu imajinasi, cipta tanpa batas.',
          },
          {
            icon: require('@/assets/solution/icon4.png'),
            title: 'Kursus kaya',
            description:
              'Kursus pendamping dari dasar hingga praktik; membantu siswa membangun kerangka pengetahuan.',
          },
        ],
      },
      scenes: {
        title: 'Kenali kursus unggulan kami',
        items: [
          {
            tab: 'Pendidikan sekolah',
            title: 'Pendidikan AI di sekolah',
            desc: 'Gunakan paket AI untuk membuat asisten suara pintar; praktik membangkitkan minat, melatih logika & pemrograman, merasakan daya tarik AI.',
            image: require('@/assets/solution/tc1.png'),
          },
          {
            tab: 'Pelatihan kompetisi',
            title: 'Pelatihan kompetisi',
            desc: 'Paket cerdas mendukung kompetisi robot & inovasi teknologi; siswa merancang karya cerdas, meningkatkan kolaborasi & kreativitas.',
            image: require('@/assets/solution/tc2.png'),
          },
          {
            tab: 'Belajar di rumah',
            title: 'Belajar di rumah',
            desc: 'Belajar proyek AI bersama orang tua, melatih keterampilan praktik, mempererat hubungan, meningkatkan literasi teknologi.',
            image: require('@/assets/solution/tc3.png'),
          },
        ],
      },
      split: {
        title: 'AI + Pendidikan: Membuka era pembelajaran cerdas',
        desc: 'Manfaatkan teknologi AI untuk jalur belajar yang dipersonalisasi & pengajaran presisi, membuat setiap siswa bebas menjelajah samudra pengetahuan.',
        image: require('@/assets/solution/banner1.png'),
      },
      kits: {
        title: 'Seri Paket STEM',
        images: [
          require('@/assets/solution/kits1.png'),
          require('@/assets/solution/kits2.png'),
          require('@/assets/solution/kits3.png'),
          require('@/assets/solution/kits4.png'),
        ],
      },
    },
    makerSpace: {
      banner: {
        alt: 'Banner Solusi Maker Space',
        title: 'Jelajahi maker space kami',
        description:
          'Di maker space, pendidikan berpadu dengan teknologi inovatif, menyediakan platform praktik & eksplorasi bagi siswa',
        image: require('@/assets/solution/spacebanner.png'),
      },
      intro: {
        title: 'Keterampilan maker yang menyeluruh',
        items: [
          {
            icon: require('@/assets/solution/icon5.png'),
            title: 'Aplikasi alat teknologi',
            desc: 'Pemrograman visual, mudah dipelajari; pemula segera membuat proyek AI',
          },
          {
            icon: require('@/assets/solution/icon6.png'),
            title: 'Keterbukaan & fleksibilitas',
            desc: 'Maker space untuk eksplorasi bebas; taman kreatif yang istimewa.',
          },
          {
            icon: require('@/assets/solution/icon7.png'),
            title: 'Praktik langsung',
            desc: 'Buat, bereksperimen, dan mengeksplorasi—mulai perjalanan belajar.',
          },
          {
            icon: require('@/assets/solution/icon8.png'),
            title: 'Pembelajaran kolaboratif',
            desc: 'Dorong siswa bekerja dalam tim; kembangkan kolaborasi & komunikasi.',
          },
        ],
      },
      scenes: {
        title: 'Skenario penerapan maker space',
        items: [
          {
            tab: 'Kelas kerajinan sekolah',
            title: 'Kelas kerajinan sekolah',
            desc: 'Pelengkap kuat untuk kursus kerajinan dan desain seni.',
            image: require('@/assets/solution/tc4.png'),
          },
          {
            tab: 'Klub praktik inovasi',
            title: 'Klub praktik inovasi',
            desc: 'Sediakan platform praktik untuk klub inovasi sekolah.',
            image: require('@/assets/solution/tc5.png'),
          },
          {
            tab: 'Laboratorium pendidikan',
            title: 'Laboratorium pendidikan',
            desc: 'Cocok untuk sekolah, universitas, atau laboratorium; perbarui lingkungan belajar, sediakan mesin ukir laser profesional untuk siswa.',
            image: require('@/assets/solution/tc6.png'),
          },
        ],
      },
      split: {
        title: 'Alat untuk mewujudkan kreativitas',
        desc: 'Dengan pemotongan presisi mesin laser dan interaksi cerdas robot pemrograman, siswa dapat mengubah ide abstrak menjadi karya nyata.',
        image: require('@/assets/solution/banner2.png'),
      },
      kits: {
        title: 'Seri paket maker',
        images: [
          require('@/assets/solution/kits5.png'),
          require('@/assets/solution/kits6.png'),
          require('@/assets/solution/kits7.png'),
          require('@/assets/solution/kits8.png'),
        ],
      },
    },
  },
  software: {
    banner: {
      alt: 'Banner halaman perangkat lunak',
      title: 'Pusat Perangkat Lunak Zetok',
      image: require('@/assets/software/banner.png'),
    },
    download: {
      title: 'Unduhan Perangkat Lunak',
      items: [
        {
          key: 'lightmaker-app',
          icon: require('@/assets/software/s1.png'),
          name: 'Light Maker App',
          buttonText: 'Unduh versi seluler',
          link: '#',
        },
        {
          key: 'goodlaser-lightmaker',
          icon: require('@/assets/software/s2.png'),
          name: 'Good-laser Light Maker',
          buttonText: 'Unduh klien',
          link: '#',
        },
        {
          key: 'zz-learning-app',
          icon: require('@/assets/software/s3.png'),
          name: 'Aplikasi Platform Pembelajaran Zhongze',
          buttonText: 'Unduh versi seluler',
          link: '#',
        },
        {
          key: 'zz-learning-platform',
          icon: 'https://picsum.photos/seed/sw-app-4/88/88',
          name: 'Platform Pembelajaran Teknologi Zhongze',
          buttonText: 'Unduh klien',
          link: '#',
        },
      ],
    },
    intro: {
      'goodlaser-lightmaker': {
        header: {
          title: 'Light Maker — Perangkat lunak khusus perangkat laser',
          desc: 'Menggabungkan desain grafis dan kontrol perangkat dalam satu, menghemat banyak waktu dan menyediakan solusi terpadu untuk desain serta kontrol laser.',
        },
        items: [
          {
            image: require('@/assets/software/s1.png'),
            title: 'Sistem desain kuat & mudah digunakan',
            desc: 'Perangkat lunak kreasi yang kuat, kompatibel dengan desain berkualitas dalam format JPG, DXF, AI, DST, PNG, BMP, TIF, SVG, DWG, dan lainnya.',
          },
          {
            image: require('@/assets/software/s2.png'),
            title: 'Profesional',
            desc: 'Fungsi gambar profesional untuk memenuhi semua kebutuhan pembuatan; baik desain kompleks maupun pemotongan sederhana, mudah diatasi.',
          },
          {
            image: require('@/assets/software/s3.png'),
            title: 'Mudah dioperasikan',
            desc: 'Antarmuka ramah pengguna dan mendukung beragam perangkat laser; kemudahan penggunaan, antarmuka multifungsi, serta pemrosesan pemotongan & ukir yang efisien.',
          },
        ],
      },
      'lightmaker-app': {
        header: {
          title: 'Light Maker — Perangkat lunak khusus perangkat laser',
          desc: 'Menggabungkan desain grafis dan kontrol perangkat dalam satu, menghemat banyak waktu dan menyediakan solusi terpadu untuk desain serta kontrol laser.',
        },
        items: [
          {
            image: require('@/assets/software/s1.png'),
            title: 'Sistem desain kuat & mudah digunakan',
            desc: 'Perangkat lunak kreasi yang kuat, kompatibel dengan desain berkualitas dalam format JPG, DXF, AI, DST, PNG, BMP, TIF, SVG, DWG, dan lainnya.',
          },
          {
            image: require('@/assets/software/s2.png'),
            title: 'Profesional',
            desc: 'Fungsi gambar profesional untuk memenuhi semua kebutuhan pembuatan; baik desain kompleks maupun pemotongan sederhana, mudah diatasi.',
          },
          {
            image: require('@/assets/software/s3.png'),
            title: 'Mudah dioperasikan',
            desc: 'Antarmuka ramah pengguna dan mendukung beragam perangkat laser; kemudahan penggunaan, antarmuka multifungsi, serta pemrosesan pemotongan & ukir yang efisien.',
          },
        ],
      },
      'zz-learning-app': {
        header: {
          title: 'Platform Cloud Zetok',
          desc: 'Platform cloud adalah alat manajemen pendidikan inovatif yang menyediakan solusi satu atap bagi guru, siswa, dan sekolah. Melalui platform kami, Anda dapat dengan mudah mengirim/mengumpulkan tugas, memantau perangkat, melaporkan kerusakan, serta mengonfigurasi parameter.',
        },
        items: [
          {
            image: require('@/assets/software/c1.png'),
            title: 'Kemudahan operasi',
            desc: 'Pembuatan satu-klik: pustaka bawaan & konfigurasi parameter mendukung pembuatan sekali klik, menyederhanakan alur kerja. Pemantauan perangkat: pantau status perangkat secara real-time untuk memastikan kegiatan belajar berjalan lancar.',
          },
          {
            image: require('@/assets/software/c2.png'),
            title: 'Manajemen terpusat',
            desc: 'Perangkat paralel: mendukung perangkat lain di kelas maker dalam koneksi paralel; fungsi manajemen satu-klik meningkatkan efisiensi.',
          },
          {
            image: require('@/assets/software/c3.png'),
            title: 'Pemantauan real-time',
            desc: 'Status perangkat: ketahui status operasi perangkat secara real-time dan laporkan kerusakan segera ketika terjadi. Pemeliharaan: sistem mengingatkan secara berkala berdasarkan waktu operasi & frekuensi penggunaan, memperpanjang umur perangkat dan meningkatkan kualitas pemotongan.',
          },
        ],
      },
      'zz-learning-platform': {
        header: {
          title: 'Platform Pembelajaran Zetok',
          desc: 'Platform Pembelajaran Zetok adalah alat pembelajaran online inovatif yang menyediakan solusi perangkat lunak pendidikan komprehensif bagi siswa dan guru. Baik di perangkat seluler maupun komputer, pengguna dapat mengakses dan menggunakan platform kami dengan mudah.',
        },
        items: [
          {
            image: require('@/assets/software/pc1.png'),
            title: 'Cerdas & praktis, ramah pemula',
            desc: 'Memiliki pustaka kaya dan parameter pra-setel, mendukung pembuatan satu-klik; pemula cepat mulai. Panduan pemula di ponsel detail, membantu menguasai cara operasi. Layanan cloud mendukung pemantauan real-time perangkat kelas di latar belakang untuk memastikan proses belajar aman & efisien.',
          },
          {
            image: require('@/assets/software/pc2.png'),
            title: 'Kreasi AI',
            desc: 'Fitur pembuatan satu-klik dan generasi gambar AI menyederhanakan proses desain serta meningkatkan efisiensi. Masukkan instruksi sederhana atau unggah gambar referensi, AI akan menghasilkan materi berkualitas tinggi yang siap dipotong.',
          },
          {
            image: require('@/assets/software/pc3.png'),
            title: 'Pengalaman belajar efisien yang baru',
            desc: 'Platform Pembelajaran Zetok mengintegrasikan pembelajaran kursus, desain grafis, dan pemrosesan pemotongan laser dalam satu; operasi sederhana & nyaman, pengguna cepat mulai. Beranda menggunakan desain kartu untuk membedakan modul pembelajaran, desain grafis, dan pemotongan laser, menjadikan pembelajaran, desain, dan pemrosesan tersambung mulus serta meningkatkan efisiensi.',
          },
        ],
      },
    },
  },
  product: {
    farm: {
      banner: {
        alt: 'Spanduk Pertanian Cerdas',
        title: 'Perangkat Pembelajaran Pertanian Cerdas',
        btnText: 'Beli sekarang',
        description:
          'Pengajaran berbasis proyek | Pemrograman + perangkat keras + AI | Cocok untuk SD/SMP',
        image: require('@/assets/product/farm/banner.png'),
      },
      sections: {
        courseTitle: 'Konten kursus proyek',
        resourceTitle: 'Sumber daya pengajaran',
        equipmentsTitle: 'Konfigurasi peralatan',
      },
      courses: [
        {
          bg: '#FBBC05',
          txt: '#fff',
          title: 'Konten kursus beragam',
          desc: '12 pelajaran bertahap: dari deteksi suhu hingga irigasi cerdas dan pengendalian suhu, peningkatan menyeluruh dalam satu paket.',
          image: require('@/assets/product/farm/education1.png'),
        },
        {
          bg: '#4285F4',
          txt: '#fff',
          title: 'Integrasi lintas disiplin',
          desc: 'Setiap proyek melibatkan pemrograman, perangkat elektronik, dan struktur mekanik, membantu siswa mengintegrasikan pengetahuan secara praktis serta meningkatkan kemampuan berpikir lintas disiplin.',
          image: require('@/assets/product/farm/education2.png'),
        },
        {
          bg: '#EA4335',
          txt: '#fff',
          title: 'Tema kontekstual kehidupan',
          desc: 'Bertema pertanian cerdas, dekat dengan kehidupan siswa, mudah memicu minat belajar dan antusiasme partisipasi.',
          image: require('@/assets/product/farm/education3.png'),
        },
      ],
      resources: [
        {
          title: 'PPT dan handout lengkap',
          desc: 'PPT dan handout untuk 16 sesi, terhubung erat dengan proyek pengajaran, menyediakan materi melimpah dan mengurangi beban persiapan guru.',
          image: require('@/assets/product/farm/edu1.png'),
        },
        {
          title: 'Video perakitan kursus berbasis proyek',
          desc: 'Video secara visual menampilkan proses perakitan proyek, membantu siswa memahami dan menguasai langkah-langkah operasi, meningkatkan efisiensi belajar.',
          image: require('@/assets/product/farm/edu2.png'),
        },
        {
          title: 'Materi pendukung pengajaran',
          desc: 'Handout dan materi pendukung memberikan panduan belajar lebih rinci, memudahkan siswa untuk review dan belajar mandiri setelah kelas.',
          image: require('@/assets/product/farm/edu3.png'),
        },
      ],
      equipments: [
        {
          title: 'Strip lampu RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Modul jam DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Sensor suhu & kelembapan DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Sensor gerak tubuh',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Modul pencahayaan LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Modul kipas',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Sakelar optokopler celah',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Modul tombol',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Papan kendali',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Papan ekspansi',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    home: {
      banner: {
        alt: 'Paket Pembelajaran Rumah Pintar',
        title: 'Paket Pembelajaran Rumah Pintar',
        btnText: 'Beli sekarang',
        description:
          'Pemrograman & Pengenalan AI | Pembelajaran berbasis proyek | Pilihan utama kelas teknologi SD/SMP',
        image: require('@/assets/product/home/banner.png'),
      },
      resourcesTitle: 'Keunggulan Paket Pemula Rumah Pintar',
      resources: [
        {
          title: 'Sumber daya lengkap',
          desc: 'Menyediakan sumber daya pengajaran yang lengkap, memudahkan guru mengajar dan siswa belajar.',
          image: require('@/assets/product/home/adv1.png'),
        },
        {
          title: 'Integrasi lintas disiplin',
          desc: 'Setiap proyek mencakup pemrograman, perangkat elektronik, struktur mekanik, dan disiplin lainnya; membantu siswa mengintegrasikan pengetahuan secara praktis dan meningkatkan kemampuan berpikir lintas disiplin.',
          image: require('@/assets/product/home/adv2.png'),
        },
        {
          title: 'Tugas lanjutan setelah kelas',
          desc: 'Tugas lanjutan dan saran penerapan lintas disiplin mendorong eksplorasi dan kreasi.',
          image: require('@/assets/product/home/adv3.png'),
        },
      ],
      course: {
        title: 'Kursus pendamping',
        desc: 'Mencakup 12 kursus proyek berkualitas, meliputi berbagai aspek rumah pintar seperti bel pintu elektronik, lampu teras dengan pengaturan intensitas, garasi bersensor, akses pintu dengan sandi, peringatan gas, alarm anti-pencurian, lampu warna-warni, lampu suasana musik, deteksi cahaya, deteksi suhu ruangan, dan kipas dengan kontrol suhu.',
        image: require('@/assets/product/home/banner2.png'),
      },
      scenesTitle: 'Beragam skenario penerapan',
      scenes: [
        {
          title: 'Pengajaran di kelas',
          image: require('@/assets/product/home/c1.png'),
        },
        {
          title: 'Pengembangan kreativitas mandiri',
          image: require('@/assets/product/home/c2.png'),
        },
        {
          title: 'Interaksi orang tua–anak di rumah',
          image: require('@/assets/product/home/c3.png'),
        },
        {
          title: 'Pameran kegiatan',
          image: require('@/assets/product/home/c4.png'),
        },
      ],
      equipmentsTitle: 'Konfigurasi peralatan',
      equipments: [
        {
          title: 'Strip lampu RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Modul jam DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Sensor suhu & kelembapan DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Sensor gerak tubuh',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Modul pencahayaan LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Modul kipas',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Sakelar optokopler celah',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Modul tombol',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Papan kendali',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Papan ekspansi',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    factory: {
      banner: {
        alt: 'Banner Pabrik Pintar',
        title: 'Paket Pembelajaran Pabrik Pintar',
        btnText: 'Beli sekarang',
        description: ` · Cakupan menyeluruh sensor/kontrol/aktuasi <br>
 · Mensimulasikan lini produksi nyata<br>
 · Membina "insinyur masa depan"`,
        image: require('@/assets/product/factory/banner.png'),
      },
      resourcesTitle: 'Fitur Produk',
      resources: [
        {
          title: 'Pengalaman inti Industri 4.0',
          desc: 'Siswa berlatih sensor, kontrol, aktuasi, dan manajemen data pada lini produksi simulasi.',
          image: require('@/assets/product/factory/tc1.png'),
        },
        {
          title: 'Pembelajaran berbasis proyek',
          desc: 'Mencakup tutorial pemrograman serta 12 sesi kursus lengkap dengan PPT, memudahkan pembelajaran.',
          image: require('@/assets/product/factory/tc2.png'),
        },
        {
          title: 'Simulasi skenario nyata',
          desc: 'Lengan robot pintar, sistem klasifikasi otomatis, gudang pintar; mensimulasikan manajemen logistik dan inventaris, memulai perjalanan praktik STEM.',
          image: require('@/assets/product/factory/tc3.png'),
        },
      ],
      intro: {
        title: 'Pengantar Produk',
        desc: 'Paket pembelajaran pabrik pintar merupakan kit pembelajaran berbasis proyek yang menggabungkan pemrograman, perangkat elektronik, struktur mekanik, pemotongan laser, dan pengenalan AI. Cocok untuk penggunaan dan pengajaran di tingkat SD/SMP. Bertema "Manufaktur Cerdas · Kreasi untuk Masa Depan", melalui simulasi lingkungan produksi, mengasah kemampuan penyelidikan ilmiah, desain rekayasa, kontrol pemrograman, dan kolaborasi inovatif siswa.',
        bg: require('@/assets/product/factory/product.png'),
      },
      course: {
        title: 'Kursus pendamping',
        desc: '12 kursus unggulan: mencakup pengantar pabrik pintar, pemahaman alur produksi, aplikasi sensor, dasar penggerak mekanik, pembangunan sistem konveyor, penyortiran otomatis, kontrol kolaborasi stasiun kerja, perakitan lengan mekanik, penyortiran pintar, dan lainnya. Kursus berbasis proyek tentang kontrol dan akuisisi data menekankan praktik langsung dan pelatihan sistematis.',
        image: require('@/assets/product/factory/course.png'),
      },
      equipmentsTitle: 'Konfigurasi Peralatan',
      equipments: [
        {
          title: 'Strip lampu RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Modul jam DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Sensor suhu & kelembapan DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Sensor gerak tubuh',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Modul pencahayaan LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Modul kipas',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Sakelar optocoupler tipe slot',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Modul tombol',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Papan kontrol',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Papan ekspansi',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    kits: {
      laserSteam: {
        banner: {
          alt: 'Spanduk Paket STEAM Pemotongan Laser',
          title: 'Paket STEAM Pemotongan Laser',
          btnText: 'Beli sekarang',
          description:
            'Solusi pendidikan manufaktur satu atap untuk menumbuhkan kreativitas dan kolaborasi tim',
          image: require('@/assets/product/laser-steam/banner.png'),
        },
        aiBanner: {
          title: 'Pendidikan AI, awal yang cerdas',
          desc: 'Menggabungkan pendidikan STEAM dengan elemen AI untuk pengalaman belajar menyeluruh.',
        },
        resourcesTitle: 'Keunggulan Paket STEAM Pemotongan Laser',
        resources: [
          {
            title: 'Teori kecerdasan majemuk',
            desc: 'Berdasarkan teori kecerdasan majemuk, kursus mengembangkan kreativitas, berpikir kritis, pemecahan masalah, serta kemampuan komunikasi dan kolaborasi.',
            image: require('@/assets/product/laser-steam/adv1.png'),
          },
          {
            title: 'Pembelajaran berbasis proyek',
            desc: 'Melalui pembelajaran berbasis proyek, siswa belajar melalui praktik, meningkatkan efisiensi dan minat belajar.',
            image: require('@/assets/product/laser-steam/adv2.png'),
          },
          {
            title: 'Pendidikan STEAM',
            desc: 'Konten kursus menggabungkan sains, teknologi, rekayasa, seni, dan matematika, membantu siswa membangun pola pikir lintas disiplin.',
            image: require('@/assets/product/laser-steam/adv3.png'),
          },
        ],
        teach: {
          title: 'Pengajaran terperinci pendukung',
          tabs: [
            { key: 'cutter', label: 'Mesin pemotong laser' },
            { key: 'lesson', label: 'Kursus pendukung' },
            { key: 'material', label: 'Material pengajaran' },
            { key: 'software', label: 'Perangkat lunak' },
          ],
          images: {
            cutter: require('@/assets/product/laser-steam/cutter.png'),
            lesson: require('@/assets/product/laser-steam/lesson.png'),
            material: require('@/assets/product/laser-steam/material.png'),
            software: require('@/assets/product/laser-steam/software.png'),
          },
        },
        equipmentsTitle: 'Konfigurasi peralatan',
      },
      // 逐梦科学套件（Dream Science Kit）
      dreamScience: {
        banner: {
          alt: 'Spanduk Paket Dream Science',
          title: 'Kotak Sains Menakjubkan (Paket Dream Science)',
          description:
            'Konsep ilmiah dasar | Pemikiran ilmiah | Praktik eksplorasi | Sikap dan tanggung jawab',
          image: require('@/assets/product/dream-science/banner.png'),
        },
        resourcesTitle: 'Isi paket',
        resources: [
          {
            title: 'Bahan eksperimen sains',
            desc: 'Digunakan untuk menyelesaikan berbagai eksperimen dan proyek sains.',
            image: require('@/assets/product/dream-science/kits1.png'),
          },
          {
            title: 'Sumber daya pengajaran',
            desc: 'Termasuk PPT dan handout pengajaran, mendukung kegiatan mengajar selama satu semester, dengan konten yang terkait erat dengan proyek pengajaran dan poin-poin pengetahuan.',
            image: require('@/assets/product/dream-science/kits2.png'),
          },
          {
            title: 'Video perakitan dan handout',
            desc: 'Materi pendukung pengajaran, membantu siswa memahami dan menguasai langkah-langkah operasi dengan lebih baik.',
            image: require('@/assets/product/dream-science/kits3.png'),
          },
        ],
        objectivesTitle: 'Tujuan pengajaran',
        objectives: [
          {
            title: 'Kemampuan penyelidikan ilmiah',
            desc: 'Mengajukan pertanyaan, membuat rencana, mengumpulkan dan menganalisis data',
            image: require('@/assets/product/dream-science/education1.png'),
          },
          {
            title: 'Kemampuan praktik rekayasa',
            desc: 'Merakit dan menguji, memperbaiki solusi secara iteratif',
            image: require('@/assets/product/dream-science/education2.png'),
          },
          {
            title: 'Integrasi lintas disiplin',
            desc: 'Menggabungkan matematika, fisika, dan seni untuk menyelesaikan proyek',
            image: require('@/assets/product/dream-science/education3.png'),
          },
        ],
        intro: {
          title: 'Sasaran pengguna',
          description:
            'Siswa SD/SMP: cocok untuk berbagai jenjang usia dan membantu meningkatkan literasi sains serta kemampuan praktik. Guru: menyediakan sumber daya dan panduan pengajaran, membantu menjalankan kegiatan belajar-mengajar dengan lebih baik.',
          image: require('@/assets/product/dream-science/banner1.png'),
          alt: 'Gambar bagian pengenalan',
        },
      },
    },
    // 查看所有套件页面
    kitsViewAll: {
      banner: {
        alt: 'Spanduk Lihat Semua Paket',
        title: 'Seri Paket',
        image: require('@/assets/product/kitsall/banner.png'),
      },
      contentTitle:
        'Berbasis proyek, siswa menyelesaikan berbagai tugas proyek untuk melatih kemampuan menerapkan pengetahuan secara komprehensif dalam memecahkan masalah.',
      moreText: 'Pelajari lebih lanjut',
      items: [
        {
          image: require('@/assets/product/kitsall/kits1.png'),
          title: 'Perangkat Pembelajaran Pertanian Cerdas',
          desc: 'Berbasis proyek, memicu kreativitas dan kemampuan praktik siswa, serta mengasah keterampilan pemecahan masalah nyata.',
          link: '/products/laser-steam',
        },
        {
          image: require('@/assets/product/kitsall/kits2-1.png'),
          title: 'Perangkat Pembelajaran Rumah Cerdas',
          desc: 'Menggabungkan pemrograman, perangkat elektronik, struktur mekanik, pemotongan laser, dan pengenalan AI untuk pengalaman belajar yang komprehensif.',
          link: '/products/dream-science',
        },
        {
          image: require('@/assets/product/kitsall/kits2-2.png'),
          title: 'Perangkat Pembelajaran Transportasi Cerdas',
          desc: 'Kit pengajaran berbasis proyek yang memadukan pemrograman, perangkat elektronik, struktur mekanik, pemotongan laser, dan pengenalan AI.',
          link: '/products',
        },
        {
          image: require('@/assets/product/kitsall/kits2-3.png'),
          title: 'Perangkat Pembelajaran Pabrik Cerdas',
          desc: 'Mencakup dasar-dasar AI dan studi kasus praktis, membimbing siswa belajar secara bertahap dan membangun sistem pengetahuan secara sistematis.',
          link: '/products/traffic',
        },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'Paket STEAM Pemotongan Laser',
        //   desc: 'Paket kursus STEAM pemotongan laser dipandu oleh teori kecerdasan majemuk, filosofi pendidikan STEAM, dan teori pembelajaran berbasis proyek.',
        //   link: '/products/home',
        // },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'Paket Dream Science',
        //   desc: 'Paket Dream Science memenuhi kebutuhan berbagai tahap belajar, membangkitkan minat sains dan semangat eksplorasi siswa.',
        //   link: '/products/farm',
        // },
      ],
    },
    traffic: {
      banner: {
        alt: 'Spanduk Transportasi Cerdas',
        title: 'Perangkat Pembelajaran Transportasi Cerdas',
        btnText: 'Beli sekarang',
        description: `12 kursus berbasis proyek 
  <br>· Pemrograman ganda Grafis/Python  <br>
  · Simulasi skenario nyata<br>
  · Siap pakai & siap mengajar`,
        image: require('@/assets/product/traffic/banner.png'),
      },
      resourcesTitle: 'Fitur Produk',
      resources: [
        {
          title: 'Penelusuran ilmiah dan inovasi',
          desc: 'Siswa membangun sistem transportasi cerdas dengan modul elektronik dan struktur mekanik',
          image: require('@/assets/product/traffic/traffic1.png'),
        },
        {
          title: 'Nilai edukatif tinggi',
          desc: 'Dapat membangun proyek seperti lampu jalan cerdas, lampu lalu lintas, zebra cross, dan area parkir, membantu siswa memahami konsep transportasi cerdas.',
          image: require('@/assets/product/traffic/traffic2.png'),
        },
        {
          title: 'Sumber daya kaya',
          desc: 'Dilengkapi sumber daya pengajaran lengkap, termasuk PPT dan handout untuk 12 pelajaran, video perakitan kursus berbasis proyek, dan materi pendukung lainnya.',
          image: require('@/assets/product/traffic/traffic3.png'),
        },
      ],
      intro: {
        title: 'Deskripsi produk',
        desc: 'Perangkat transportasi cerdas untuk siswa SD/SMP bertema “Perjalanan Cerdas” dan “Keselamatan Lalu Lintas”, menggabungkan kontrol elektronik dan teknologi sensor, membimbing siswa merancang serta membangun sistem transportasi cerdas sendiri, mensimulasikan skenario lalu lintas nyata, dan menumbuhkan literasi sains serta kemampuan inovasi.',
        bg: require('@/assets/product/traffic/banner1.png'),
      },
      course: {
        title: 'Kursus pendukung',
        desc: 'Mencakup kursus berbasis proyek tentang dasar persepsi dan kontrol lalu lintas, pengaitan sinyal, perencanaan rute, menyesuaikan berbagai tahap dan alokasi jam pelajaran.',
        image: require('@/assets/product/traffic/course.png'),
      },
      equipmentsTitle: 'Konfigurasi peralatan',
      equipments: [
        {
          title: 'Strip lampu RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Modul jam DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Sensor suhu & kelembapan DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Sensor gerak tubuh',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Modul pencahayaan LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Modul kipas',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Sakelar optokopler celah',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Modul tombol',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Papan kendali',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Papan ekspansi',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    banner: {
      alt: 'Spanduk beranda produk',
      title: 'Produk dan Solusi Zetok',
      description:
        'Kit, kursus, perangkat, dan perangkat lunak terintegrasi, mendukung pembelajaran berbasis proyek',
      image: 'https://picsum.photos/id/1069/1600/900',
    },
    courses: {
      banner: {
        alt: 'Spanduk komponen kursus',
        title: 'Empat sistem kursus',
        description:
          'Konten kursus mencakup berbagai bidang disiplin STEAM (Sains, Teknologi, Rekayasa, Seni, dan Matematika), mendorong integrasi dan penerapan pengetahuan lintas disiplin.',
        image: require('@/assets/product/courses/banner.png'),
      },
      design: {
        title: 'Kenali kursus unggulan kami',
        nav: ['Usia 3–6', 'Usia 6–12', 'Usia 8–13', 'Usia 9–15'],
        entries: [
          {
            title: 'Sistem Eksplorasi Sains · Anak usia dini (6 pelajaran)',
            desc: 'Melalui fenomena umum dalam kehidupan, menggunakan alat bantu sains untuk eksplorasi lebih lanjut guna memahami aturan dan prinsip perkembangan benda.',
            image: require('@/assets/product/courses/courses1.png'),
          },
          {
            title: 'Sistem Maker STEAM · Remaja (3 pelajaran)',
            desc: 'Mengembangkan kreativitas, menggunakan perangkat, berlatih langsung, mengubah ide menjadi karya.',
            image: require('@/assets/product/courses/courses2.png'),
          },
          {
            title: 'Sistem Kursus Pemotongan Laser (3 pelajaran)',
            desc: 'Menggunakan perangkat untuk memotong beragam komponen struktural, merakit menjadi struktur tiga dimensi, dan mempercantik hasil. Kemampuan pemrograman: memahami logika dan prinsip pengambilan keputusan dalam pemrograman.',
            image: require('@/assets/product/courses/courses3.png'),
          },
          {
            title: 'Sistem Kursus Kecerdasan Buatan (4 pelajaran)',
            desc: 'Menggunakan perangkat dan alat, merancang tampilan karya, serta melalui pemrograman membuat karya menjadi cerdas dan sederhana untuk menyelesaikan masalah sehari-hari.',
            image: require('@/assets/product/courses/courses4.png'),
          },
        ],
        detailsTitle: 'Keunggulan kursus',
        details: [
          {
            title: 'Tingkat praktik tinggi',
            description: 'Praktik langsung, teori menjadi keterampilan',
            image: require('@/assets/product/courses/icon1.png'),
          },
          {
            title: 'Pengembangan berpikir kreatif',
            description: 'Merancang langsung, solusi kreatif terhadap masalah',
            image: require('@/assets/product/courses/icon2.png'),
          },
          {
            title: 'Pembelajaran berbasis proyek',
            description:
              'Belajar berbasis proyek, menguasai pengetahuan melalui praktik',
            image: require('@/assets/product/courses/icon3.png'),
          },
          {
            title: 'Eksplorasi teknologi mutakhir',
            description:
              'Mengikuti teknologi mutakhir, mempelajari penerapan paket cerdas',
            image: require('@/assets/product/courses/icon4.png'),
          },
          {
            title: 'Pengajaran sistematis',
            description:
              'Konten kursus bertahap, dari teori dasar hingga praktik',
            image: require('@/assets/product/courses/icon5.png'),
          },
          {
            title: 'Menarik dan menantang sekaligus',
            description:
              'Kesenangan memicu minat, tantangan memicu potensi; bertumbuh melalui eksplorasi.',
            image: require('@/assets/product/courses/icon6.png'),
          },
        ],
      },
      ai: {
        title: 'Seri kursus AI',
        items: [
          {
            name: 'Pertanian cerdas',
            image: require('@/assets/product/courses/courses5.png'),
          },
          {
            name: 'Rumah cerdas',
            image: require('@/assets/product/courses/courses6.png'),
          },
          {
            name: 'Transportasi cerdas',
            image: require('@/assets/product/courses/courses7.png'),
          },
          {
            name: 'Pabrik cerdas',
            image: require('@/assets/product/courses/courses8.png'),
          },
        ],
      },
      aiBanner: {
        alt: 'Spanduk kursus AI',
        text: 'Berbasis proyek, integrasi lintas disiplin, membina kemampuan praktik, kolaborasi, dan pemecahan masalah. Menjunjung keamanan dan karakter, pameran hasil meningkatkan rasa pencapaian, mendukung pertumbuhan siswa.',
        image: require('@/assets/product/courses/banner1.png'),
      },
    },
    laser: {
      banner: {
        alt: 'Produk laser',
        title: 'Produk Laser Good Laser',
        description:
          'Perangkat dan solusi pemotongan/ukir laser yang aman dan mudah digunakan untuk skenario pendidikan',
        image: require('@/assets/product/laser/banner.png'),
      },
      advantagesTitle: 'Keunggulan kami',
      extraNote: {
        light640_640:
          'Hasil pemotongan dan ukir yang mengagumkan\nBeragam model dan konfigurasi daya laser untuk berbagai kebutuhan aplikasi\nJenis laser: DC CO2  Daya laser: 60W–130W',
      },
      center: {
        title: 'Pusat produk',
        laser_accessories: 'Aksesori Laser',
        air_purifier_name: 'Pembersih Udara',
        description:
          'Menyediakan paket konfigurasi perangkat laser sesuai tingkat pengajaran di sekolah; Zetok merilis empat paket perangkat laser resmi, sekolah dapat memilih sesuai kebutuhan pengajaran nyata.',
        tabs: [
          {
            key: 'light530',
            label: 'Light 530',
            images: [
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Laser berkualitas tinggi dan presisi tinggi',
                bgColor: '#4285F4',
                description:
                  'Tabung laser CO2 berkualitas tinggi yang tebal, panjang gelombang 10.640 nm, menghasilkan laser CO2 55W berkualitas; ketebalan potong maksimum hingga 20 mm (akrilik), kecepatan kerja hingga 600 mm/s, dengan akurasi pengulangan posisi 0,025 mm, memungkinkan pemotongan dan pengukiran cepat serta presisi untuk karya kreatif yang halus.',
                image: require('@/assets/product/laser/light530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title:
                  'Kotak sistem filtrasi gas buang tiga tahap terintegrasi',
                bgColor: '#FFBC0C',
                description:
                  'Desain terintegrasi kotak filtrasi asap dengan jaring filter, karbon aktif, dan lapisan UV ozon; lebih bersih dan ramah lingkungan, penempatan produk lebih ringkas dan mudah, tanpa perlu membeli kotak filter terpisah atau memakan ruang tambahan.',
                image: require('@/assets/product/laser/light530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Perlindungan keamanan berstandar prioritas tertinggi',
                bgColor: '#34A853',
                description:
                  'Lulus uji keselamatan tertinggi laboratorium SGS, produk laser Kelas I bersertifikasi FDA; desain lampu indikator keselamatan dan status kerja yang unik, memudahkan pemantauan kondisi operasi mesin secara jelas dan intuitif.',
                image: require('@/assets/product/laser/light530-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title:
                  'Sistem pemotongan laser yang mudah dioperasikan dan bertenaga',
                bgColor: '#0F9D58',
                description:
                  '· Menetapkan parameter proses berbeda untuk beragam material, seperti: pemotongan, ukiran dalam, ukiran ringan, pemindaian, dll. · Materi gambar yang kaya meningkatkan efisiensi desain pengguna. · Kamera mendukung pemotretan titik, membantu penyusunan grafis agar ide menjadi nyata.',
                image: require('@/assets/product/laser/light530-4.png'),
              },
            ],
          },
          {
            key: 'light640',
            label: 'Light 640',
            images: [
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
            ],
            models: [
              {
                key: '640',
                label: 'Light 640',
                image: require('@/assets/product/laser/640.png'),
              },
              {
                key: '960',
                label: 'Light 960',
                image: require('@/assets/product/laser/960.png'),
              },
              {
                key: '1390',
                label: 'Light 1390',
                image: require('@/assets/product/laser/1390.png'),
              },
              {
                key: '1610',
                label: 'Light 1610',
                image: require('@/assets/product/laser/1610.png'),
              },
            ],
            modelAdvantages: {
              640: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: '工作区域',
                  bgColor: '#4285F4',
                  description: `Light640 (600*400mm)
Light960 (900*600mm)
<br>Light1390 (1300*900mm)
<br>Light1610(1600*1000mm)`,
                  image: require('@/assets/product/laser/640-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Fokus otomatis efisien + penentuan posisi titik merah',
                  bgColor: '#FFBC0C',
                  description:
                    'Fungsi fokus otomatis dapat melakukan fokus dan penentuan posisi dengan cepat dan akurat sebelum pemotongan dan pengukiran. Dipadukan dengan berkas titik merah, posisi kerja dapat dilihat secara real-time. Seri Henghao Laser 640 menghemat banyak waktu pemotongan dan pengukiran, serta menghadirkan hasil yang lebih baik.',
                  image: require('@/assets/product/laser/640-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Desain pintu belakang terbuka',
                  bgColor: '#34A853',
                  description:
                    'Desain pintu belakang terbuka memungkinkan penempatan material pemotongan dan pengukiran dengan panjang tak terbatas; lembaran berukuran 600mm x ∞ membuat pekerjaan Anda lebih mudah dengan lebih sedikit batasan.',
                  image: require('@/assets/product/laser/640-3.png'),
                },
              ],
              960: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Hasil pemotongan dan ukir yang luar biasa',
                  bgColor: '#4285F4',
                  description:
                    'Mesin pemotong laser dengan platform pemotongan yang luas memberikan presisi dan efisiensi tingkat industri untuk pemrosesan kayu dan akrilik. Mampu memproduksi karya laser dalam jumlah besar, mendorong produktivitas dan kapasitas produksi perusahaan meningkat pesat.',
                  image: require('@/assets/product/laser/960-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Dilengkapi tabung laser berkualitas dan komponen presisi',
                  bgColor: '#FFBC0C',
                  description:
                    'Lini produk yang beragam memungkinkan pemilihan jenis laser dan kecepatan pemrosesan sesuai kebutuhan nyata, memenuhi berbagai tuntutan produksi. Memberikan kemungkinan tak terbatas untuk pemrosesan kayu, kaca, akrilik, dan lainnya.',
                  image: require('@/assets/product/laser/960-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Uji kualitas optik ketat, jaminan mutu',
                  bgColor: '#34A853',
                  description:
                    'Melalui pengujian ketat, kontrol jalur optik yang presisi, dan lebih dari 5 kali uji pemotongan serta pengukiran, memastikan pemilihan tabung laser CO2 kelas atas dengan keluaran cahaya yang stabil dan konsisten. Dengan stabilitas daya yang unggul dan titik laser yang halus, menghasilkan ukiran yang seragam bahkan pada detail yang kompleks.',
                  image: require('@/assets/product/laser/960-3.png'),
                },
              ],
              1390: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Fitur keamanan lengkap & canggih',
                  bgColor: '#4285F4',
                  description: `1. Tombol henti darurat
<br>2. Lampu peringatan
<br>3. Sakelar tahan air
<br>4. Grounding
<br>5. Alarm detektor panas bawaan yang otomatis aktif saat aktivitas mesin tidak normal
<br>6. Perlindungan penutup
<br>7. Jendela pelindung dari kaca tempered yang tahan lama`,
                  image: require('@/assets/product/laser/1390-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Tahan lama, kualitas unggul',
                  bgColor: '#FFBC0C',
                  description: `1. Sangat cocok untuk proyek tunggal atau produksi skala besar.
<br>2. Pilihan area kerja yang luas, dari 600 x 400 mm hingga 1600 x 1000 mm.
<br>3. Kecepatan ukir yang tiada banding.
<br>4. Dirancang oleh pakar industri.
<br>5. Pilihan ideal untuk kebutuhan personalisasi, pendidikan, dan aplikasi industri.`,
                  image: require('@/assets/product/laser/1390-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Optimasi produksi melalui pemantauan cerdas',
                  bgColor: '#34A853',
                  description:
                    'Dirancang untuk melindungi komponen perangkat yang sensitif (poros, kepala laser, elemen optik, lensa) dari debu dan kotoran; bahkan dalam penggunaan intensif, memastikan operasi bebas gangguan selama bertahun-tahun.',
                  image: require('@/assets/product/laser/1390-3.png'),
                },
              ],
              1610: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Fokus otomatis efisien + penentuan posisi titik merah',
                  bgColor: '#4285F4',
                  description:
                    'Fungsi fokus otomatis dapat melakukan fokus dan penentuan posisi dengan cepat dan akurat sebelum pemotongan dan pengukiran. Dipadukan dengan berkas titik merah, posisi kerja dapat dilihat secara real-time. Light 1610 menghemat banyak waktu pemotongan dan pengukiran serta menghadirkan hasil yang lebih baik.',
                  image: require('@/assets/product/laser/1610-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Hasil pemotongan dan ukir yang luar biasa',
                  bgColor: '#FFBC0C',
                  description:
                    'Mesin pemotong laser dengan platform pemotongan yang luas memberikan presisi dan efisiensi tingkat industri untuk pemrosesan kayu dan akrilik. Mampu memproduksi karya laser dalam jumlah besar, mendorong produktivitas dan kapasitas produksi meningkat pesat.',
                  image: require('@/assets/product/laser/1610-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Tahan lama, kualitas unggul',
                  bgColor: '#34A853',
                  description: `1. Sangat cocok untuk proyek tunggal atau produksi skala besar. 
<br>2. Pilihan area kerja yang luas, dari 600 x 400 mm hingga 1600 x 1000 mm.
<br>3. Kecepatan ukir yang tiada banding. 
<br>4. Dirancang oleh pakar industri. 
<br>5. Pilihan ideal untuk kebutuhan personalisasi, pendidikan, dan aplikasi industri.`,
                  image: require('@/assets/product/laser/1610-3.png'),
                },
              ],
            },
          },
          {
            key: 'lightblue530',
            label: 'Light Blue 530',
            images: [
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Mesin ukir sinar biru portabel',
                bgColor: '#4285F4',
                description:
                  'Mesin ukir sinar biru bergaya, modern, dan ringkas; cocok ditempatkan di rumah, sekolah, atau ruang studio. Kombinasi bodi logam dengan penutup akrilik yang elegan membuat mesin mungil ini pas di meja mana pun, sekaligus menghadirkan daya 20W dengan performa pemotongan yang unggul.',
                image: require('@/assets/product/laser/blue530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Pemrosesan tertutup, isolasi untuk mencegah bahaya',
                bgColor: '#FFBC0C',
                description:
                  'Mesin ukir sinar biru berdesain tertutup penuh; jika penutup dibuka saat bekerja, mesin akan otomatis berhenti. Dalam keadaan darurat, satu sakelar dapat mematikan mesin seketika. Cocok untuk penggunaan di rumah dan sekolah.',
                image: require('@/assets/product/laser/blue530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title:
                  'Pemrosesan multi-material, mendukung ratusan jenis material',
                bgColor: '#34A853',
                description:
                  'Kustomisasi beragam bentuk atau gaya produk dinamis; dengan aksesori, mendukung pengukiran bahan berbentuk beragam seperti cangkir dan benda melingkar — ideal untuk kebutuhan usaha kecil Anda.',
                image: require('@/assets/product/laser/blue530-3.png'),
              },
            ],
          },
          {
            key: 'markm20',
            label: 'Mark M20',
            images: [
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Beragam skenario aplikasi',
                bgColor: '#4285F4',
                description:
                  'Perangkat ini cocok untuk berbagai industri, termasuk pengukiran perhiasan, personalisasi objek, dan identifikasi komponen; mendukung ukiran kustom dari perhiasan, botol parfum, hingga papan nama industri kecil.',
                image: require('@/assets/product/laser/m20.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Aplikasi inovatif di bidang pendidikan',
                bgColor: '#FFBC0C',
                description:
                  'Perangkat Mark M20 menghadirkan presisi tingkat industri ke dunia pendidikan, menjadi “asisten serbaguna” untuk pendidikan sains dan teknologi; melatih kemampuan siswa dari keterampilan penandaan dasar hingga pengembangan proyek yang kompleks.',
                image: require('@/assets/product/laser/m20-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Ringkas dan modern',
                bgColor: '#34A853',
                description:
                  'Mesin penanda laser Mark M20 berdesain ringkas dan modern, jejak ruang kecil, kebisingan rendah, jendela besar, memenuhi kebutuhan daya tahan tinggi. Tampilannya elegan mematuhi standar keselamatan, cocok untuk institusi pendidikan dan lingkungan ritel publik.',
                image: require('@/assets/product/laser/m20-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Penandaan selesai dalam hitungan detik',
                bgColor: '#0F9D58',
                description:
                  'Mark M20, bahkan dengan ukuran font terkecil, dapat menyelesaikan penandaan presisi dalam hitungan detik. Kecepatan tak tertandingi ini dipadukan dengan alur kerja yang disederhanakan oleh perangkat lunak aplikasi laser LightMaker, memastikan produktivitas Anda meningkat signifikan.',
                image: require('@/assets/product/laser/m20-4.png'),
              },
            ],
          },
          {
            key: 'accessories',
            label: 'Aksesori',
            images: [
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
            ],
            advantages: [
              {
                description: `
                  · Tempat penggunaan: cocok untuk lokasi yang menghasilkan asap, bau, debu, serta gas beracun/berbahaya dan polusi udara lainnya.
<br>· Bidang aplikasi: meliputi elektronik, manufaktur mainan, perangkat logam presisi, medis, dan lainnya.
<br>· Ciri desain: desain workstation tunggal/ganda yang variabel.
<br>· Perangkat filtrasi: dilengkapi sistem filtrasi berlapis.
<br>· Pengaturan aliran udara: dapat diatur tanpa langkah sesuai volume emisi gas buang.
<br>· Efek pemurnian: efektif menyerap dan menyaring, tingkat pemurnian hingga 99,97%.
<br>· Pembuangan udara: udara bersih yang telah diproses dapat langsung dilepas di dalam ruangan。
`,
                image: require('@/assets/product/laser/accessories1.png'),
              },
              {
                description: `· Jenis perangkat: peralatan pendukung untuk mesin pemotong/ukir laser.
                     <br>· Fungsi: mewujudkan gerakan rotasi benda kerja.
<br>· Objek yang sesuai: benda berbentuk silinder, tabung, dan sejenisnya.
<br>· Fungsi perluasan: memperluas kemampuan mesin pemotong/ukir laser dari hanya memproses lembaran datar menjadi dapat memproses benda silinder.`,
                image: require('@/assets/product/laser/accessories2.png'),
              },
              {
                description: `


· Mesin pembentuk efisien yang menyediakan pemrosesan pembentukan presisi.
<br>· Dikendalikan oleh sistem CNC, pengoperasian mudah.
<br>· Beragam cetakan pembentuk tersedia.
<br>· Sistem penjepitan cepat meningkatkan efisiensi kerja.
<br>· Perangkat keselamatan lengkap.
<br>· Cocok untuk pembentukan berbagai jenis material.
`,
                image: require('@/assets/product/laser/accessories3.png'),
              },
            ],
          },
        ],
      },
    },
  },
  support: {
    afterSales: {
      banner: {
        alt: 'Banner Unduhan Tutorial',
        title: 'Unduhan Tutorial',
        image: require('@/assets/after/banner.png'),
      },
      downloadText: 'Unduh Tutorial',
      items: [
        {
          id: 'mk-1',
          name: 'Pertanian Pintar',
          image: 'https://picsum.photos/seed/as-farm1/588/391',
          link: '#',
        },
        {
          id: 'mk-2',
          name: 'Rumah Pintar',
          image: 'https://picsum.photos/seed/as-home1/588/391',
          link: '#',
        },
        {
          id: 'mk-3',
          name: 'Transportasi Pintar',
          image: 'https://picsum.photos/seed/as-traffic1/588/391',
          link: '#',
        },
        {
          id: 'mk-4',
          name: 'Pabrik Pintar',
          image: 'https://picsum.photos/seed/as-factory1/588/391',
          link: '#',
        },
        {
          id: 'mk-5',
          name: 'Ruang Maker',
          image: 'https://picsum.photos/seed/as-makerspace1/588/391',
          link: '#',
        },
        {
          id: 'mk-6',
          name: 'Kursus Robotika',
          image: 'https://picsum.photos/seed/as-robot1/588/391',
          link: '#',
        },
        {
          id: 'mk-7',
          name: 'Tutorial AI',
          image: 'https://picsum.photos/seed/as-ai1/588/391',
          link: '#',
        },
        {
          id: 'mk-8',
          name: 'Tutorial IoT',
          image: 'https://picsum.photos/seed/as-iot1/588/391',
          link: '#',
        },
      ],
    },
  },
};
